import { render, staticRenderFns } from "./client.vue?vue&type=template&id=9dc5978c&scoped=true"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"
import style0 from "./client.vue?vue&type=style&index=0&id=9dc5978c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc5978c",
  null
  
)

export default component.exports